import { render, staticRenderFns } from "./investList.vue?vue&type=template&id=fe78b566&scoped=true&"
import script from "./investList.vue?vue&type=script&lang=js&"
export * from "./investList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe78b566",
  null
  
)

export default component.exports